import { render, staticRenderFns } from "./career-item-form.vue?vue&type=template&id=63a72508&"
import script from "./career-item-form.vue?vue&type=script&lang=js&"
export * from "./career-item-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports